const shortName = (user) => {
  if (user?.user?.first_name !== "") {
    return user?.user?.first_name.substring(0, 2);
  } else {
    return user.user.email.substring(0, 2);
  }
};

export default shortName;
